var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.basket ? 'router-link' : 'span',{tag:"component",class:[
    'is-flex',
    'is-size-7',
    'has-items-aligned-center',
    'has-text-brand-contrast'
  ],attrs:{"to":{
    name: _vm.isAdmin ? 'adminOrderBasketView' : 'orderBasketStep',
    params: { basketId: _vm.$_.get(_vm.basketData, 'basketId') }
  }}},[_c('b-icon',{attrs:{"icon":"shopping-basket"}}),_vm._v(" "),_c('span',{staticClass:"has-margin-left-25"},[_c('strong',[_vm._v(_vm._s(_vm.$_.get(_vm.basket, "products", []).length))]),_vm._v(" "),_c('span',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$tc("_.item", _vm.$_.get(_vm.basket, "products", []).length).toLowerCase()))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }